import React, { useState, useEffect } from 'react'
import { Modal } from 'react-bootstrap'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import TokenManager from '../../../utils/storage/TokenManager'

const FEATURE_REQUEST_PROD_URL = 'https://idea.roscolive.com/'
const FEATURE_REQUEST_STAGE_URL = 'https://idea-stage.roscolive.com/intake/embed'

const ModalFeatureRequest = ({ onHide }) => {
	const { t } = useTranslation('translation', { keyPrefix: 'components.userDropdown' });
	const [frameSrc, setFrameSrc] = useState('');

	useEffect(() => {
		const isProd = location.hostname === 'fleet.roscolive.com';
		const featureRequestUrl = isProd
			? FEATURE_REQUEST_PROD_URL
			: FEATURE_REQUEST_STAGE_URL;

		TokenManager.getSessionToken().then((token) => {
			setFrameSrc(`${featureRequestUrl}#session_token=${encodeURIComponent(token || '')}`);
		});
	}, []);

	return (
		<Modal
			size='lg'
			show
			onHide={onHide}
			className="modalFeatureRequest modal-lg-size"
		>
			<Modal.Header closeButton>
				<Modal.Title>{t('btnFeatureRequest')}</Modal.Title>
			</Modal.Header>
			<Modal.Body style={{ padding: 0 }}>
				{frameSrc && (
					<iframe
						src={frameSrc}
						title={t('btnFeatureRequest')}
						width="100%"
						height="900"
						style={{ border: 0 }}
					/>
				)}
			</Modal.Body>
		</Modal>
	);
}

ModalFeatureRequest.propTypes = {
	onHide: PropTypes.func.isRequired
}

export default ModalFeatureRequest;
